// Format stored enum/tag values for display.
// Snake/UPPER_SNAKE tokens -> spaced Title Case. Already-spaced sentences are left as-is.
// e.g. "JUST_AN_IDEA" -> "Just An Idea", "completely_new_idea" -> "Completely New Idea".
export const formatTag = (v) => {
  if (!v || typeof v !== "string") return v;
  const s = v.trim();
  if (s.includes(" ")) return s; // already a readable sentence/label
  return s
    .replace(/_/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
};

// Percent-off between a base and final price, formatted cleanly.
// Trims trailing zeros so 20.0 -> "20", 12.5 -> "12.5", 33.333 -> "33.3".
export const formatPercentOff = (base, final) => {
  const b = Number(base) || 0;
  const f = Number(final) || 0;
  if (b <= 0 || f >= b) return "";
  const pct = ((b - f) / b) * 100;
  const rounded = Math.round(pct * 10) / 10; // 1 decimal max
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}%`;
};
